
export const setThreatsList = (items) => (dispatch, getState) => {
    const sortOrder = getState().dashboard_threatsListSortOrder;

    // 1.setting active item with the first item in the passed items
    // let activeItemId = '';
    // if (items.length > 0) {
    //     if (items[0].items) {
    //         if (sortOrder === -1) items.sort((a, b) => new Date(b._id) - new Date(a._id))
    //         if (sortOrder === 1) items.sort((a, b) => new Date(a._id) - new Date(b._id))

    //         activeItemId = items[0].items[0]._id //items are grouped by date
    //     }
    //     else activeItemId = items[0]._id //items are grouped by related threats
    // }
    // dispatch({
    //     type: 'SET_THREATS_SECTION_ACTIVE_ITEM',
    //     payload: activeItemId
    // })

    //2. setting the items
    dispatch({
        type: 'SET_THREATS_LIST',
        payload: { items, sortOrder }
    })
}

export const setThreatsItem = (item) => {
    return {
        type: 'SET_THREATS_ITEM',
        payload: item
    }
}

export const loadMoreThreats = (items) => (dispatch, getState) => {
    const sortOrder = getState().dashboard_threatsListSortOrder;
    dispatch({
        type: 'LOAD_MORE_THREATS',
        payload: { items, sortOrder }
    })
}

export const setThreatsSectionActiveItem = (itemId) => {
    return {
        type: 'SET_THREATS_SECTION_ACTIVE_ITEM',
        payload: itemId
    }
}

export const threatsListNextItem = () => (dispatch, getState) => {
    //group if items with date as _id
    const items = getState().dashboard_threatsList;
    const threatsListSortBy = getState().dashboard_threatsListSortBy;
    //creating array of ids
    let ids = [];
    if (threatsListSortBy === 'Latest Breach' && items.length > 0) {
        items.forEach(el => {
            if (el.items) ids = [...ids, ...el.items.map(item => item._id)]
        });
    } else ids = items.map(el => el._id)
    //finding the index of the current item in the ids array
    const currentIndex = ids.findIndex(id => id === getState().dashboard_threatsSectionActiveItem);
    const newItemId = ids[currentIndex + 1];
    // const currentIndex = items.findIndex(item => item._id === getState().dashboard_threatsSectionActiveItem);
    // const newItemId = items[currentIndex + 1]._id;
    dispatch({
        type: 'SET_THREATS_SECTION_ACTIVE_ITEM',
        payload: newItemId
    })
}

export const threatsListPrevItem = () => (dispatch, getState) => {
    //group if items with date as _id
    const items = getState().dashboard_threatsList;
    const threatsListSortBy = getState().dashboard_threatsListSortBy;
    //creating array of ids
    let ids = [];
    if (threatsListSortBy === 'Latest Breach' && items.length > 0) {
        items.forEach(el => {
            if (el.items) ids = [...ids, ...el.items.map(item => item._id)]
        });
    } else ids = items.map(el => el._id)
    //finding the index of the current item in the ids array
    const currentIndex = ids.findIndex(id => id === getState().dashboard_threatsSectionActiveItem);
    const newItemId = ids[currentIndex - 1];
    dispatch({
        type: 'SET_THREATS_SECTION_ACTIVE_ITEM',
        payload: newItemId
    })
}

export const setThreatsListTotalCount = (count) => {
    return {
        type: 'SET_THREATS_LIST_TOTAL_COUNT',
        payload: count
    }
}

export const setThreatsListSortBy = (sortBy) => (dispatch) => {

    dispatch({ type: 'RESET_THREATS_SECTION_PAGE' });
    dispatch({
        type: 'SET_THREATS_LIST_SORT_BY',
        payload: sortBy
    })
}

export const setThreatsListSortOrder = (sortOrder) => (dispatch) => {

    dispatch({ type: 'RESET_THREATS_SECTION_PAGE' });
    dispatch({
        type: 'SET_THREATS_LIST_SORT_ORDER',
        payload: sortOrder
    })
}

export const setThreatsListPage = (page) => {
    return {
        type: 'SET_THREATS_LIST_PAGE',
        payload: page
    }
}

export const setThreatItemCheck = (check) => {
    return {
        type: 'SET_CHECK_THREAT_ITEM',
        payload: check
    }
}